import { createSelector } from 'reselect';

export const selectOfferTable = state => state.offerTable;
export const selectOfferTableConfig = createSelector(
  selectOfferTable,
  offerTable => offerTable.config,
);

export const selectOfferTableIsLoading = createSelector(
  selectOfferTable,
  offerTable => offerTable.isLoading,
);

export const selectOfferTableIsLoaded = createSelector(
  selectOfferTable,
  offerTable => offerTable.isLoaded,
);

export const selectOfferTableData = createSelector(
  selectOfferTable,
  offerTable => offerTable.data,
);

export const selectOfferTableMetadata = createSelector(
  selectOfferTable,
  offerTable => offerTable.metadata,
);
